<script lang="ts">
  import { onMount } from 'svelte';
  import type { Component } from 'svelte';

  interface Props {
    apiBase?: string;
  }

  let { apiBase }: Props = $props();

  let terminalComponent = $state<Component | null>(null);
  let loadError = $state<string | null>(null);
  const TerminalComponent = $derived(terminalComponent);

  onMount(() => {
    void import('./TerminalPanel.svelte')
      .then((module) => {
        terminalComponent = module.default;
      })
      .catch((error) => {
        console.error('Failed to load terminal panel:', error);
        loadError = 'Terminal failed to load.';
      });
  });
</script>

{#if TerminalComponent}
  <TerminalComponent {apiBase} />
{:else if loadError}
  <div class="terminal-loading terminal-loading-error">{loadError}</div>
{:else}
  <div class="terminal-loading">Loading terminal…</div>
{/if}

<style>
  .terminal-loading {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    color: oklch(0.68 0.05 310 / 0.8);
    font-size: 0.76rem;
    letter-spacing: 0.02em;
    background: linear-gradient(180deg,
      oklch(0.09 0.02 275) 0%,
      oklch(0.07 0.02 275) 100%);
    border-top: 1px solid oklch(0.30 0.05 275 / 0.2);
  }

  .terminal-loading-error {
    color: oklch(0.78 0.16 85 / 0.88);
  }
</style>
